import { TooltipOptions } from '@openng/optimus-ui/api';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const environment = {
  production: true,
  sentryDsn: (window as any)?.env?.SENTRY_DSN || '',
  sentryTracesSampleRate: (window as any)?.env?.SENTRY_TRACES_SAMPLE_RATE || 1,
  sentryReplaysSessionSampleRate:
    (window as any)?.env?.SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0.1,
  sentryReplaysOnErrorSampleRate:
    (window as any)?.env?.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 1,
  sentryEnableLogs: (window as any)?.env?.SENTRY_SEND_DEFAULT_PII || true,
  sentrySendDefaultPii: (window as any)?.env?.SENTRY_ENABLE_LOGS || true,
  apiUrl: (window as any)?.env?.API_URL || '',
  idp_issuer: (window as any)?.env?.AUTHENTIK_ISSUER || '',
  // Falls back to the staging client, so staging keeps working without any
  // configuration. Prod sets its own client through AUTHENTIK_CLIENT_ID.
  idp_client_id:
    (window as any)?.env?.AUTHENTIK_CLIENT_ID ||
    'vr7KTEjrOE9w2rb1KnKGzGGDds4QPj0SVhIHTKF0',
  captchaSiteKey: (window as any)?.env?.FRIENDLY_CAPTCHA_SITEKEY || '',
  firstAidMaxParticipants: 12,
  firstAidMaxParticipantsWithAssistant: 16,
  qssExpiryYears: 3,
  nhkDeadlineDays: 7,
  tooltipOptions: { tooltipPosition: 'top', showDelay: 1000 } as TooltipOptions,
};
